import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './Security.module.css';

import Container from '../../../blocks/Container';

const Security = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/security.md/" } }) {
        edges {
          node {
            html
          }
        }
      }
    }
  `);

  const { html } = data.allMarkdownRemark.edges[0].node;

  return (
    <div className={styles.security}>
      <Container type="big">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Container>
    </div>
  )
};

export default Security;